import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { VisitorInfoField, VisitorInfoFieldType } from 'shared/models/visitor-info/visitor-info-field';
import { BackendFieldConverterService } from '../../../services/backend-field-converter/backend-field-converter.service';
import { TranslateService } from '@ngx-translate/core';
import { PersonType } from 'common/common/constants/person-type.enum';
import { BcRestApi } from 'common/api/rest-api';

@Component({
  selector: 'app-visitor-info-field',
  templateUrl: './visitor-info-field.component.html',
  styleUrls: ['./visitor-info-field.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class VisitorInfoFieldComponent implements OnChanges {
  @Input()
  visitorInfoField: VisitorInfoField;

  @Input()
  isNotAvailableDataHidden: boolean;

  @ViewChild('emailInput') emailInput: ElementRef;

  @ViewChild('phoneNumberInput') phoneNumberInput: ElementRef;

  public visitorInfoFieldType = VisitorInfoFieldType;
  public editingEmail: boolean = false;
  public editingPhone: boolean = false;
  public isHidden: boolean = false;

  private _lastEmail: string;
  private _lastPhone: string;
  private readonly phoneInputAllowed: RegExp = /[^+\(\)\d-. ]/g;

  constructor(private _changeDetector: ChangeDetectorRef,
              private _backendFieldConverterService: BackendFieldConverterService,
              private _translateService: TranslateService,
              private _bcRestApi: BcRestApi) {
  }

  ngOnChanges() {
    if (this.isNotAvailableDataHidden && !this.visitorInfoField.editable) {
      this.isHidden = !this.hasValue();
    }
  }

  public getValue() {
    switch (this.visitorInfoField.type) {
      case this.visitorInfoFieldType.DATE:
        return this._backendFieldConverterService.dateFormatter(<string>this.visitorInfoField.value);
      case this.visitorInfoFieldType.PERSON_TYPE:
        const personType = this._backendFieldConverterService.personTypeConverter(<PersonType>this.visitorInfoField.value);
        return personType ? this._translateService.instant(<string>personType) : '';
      case this.visitorInfoFieldType.ENDED_REASON:
        const endedReasonType = this._backendFieldConverterService.convertEndedReasonType(<number>this.visitorInfoField.value);
        return endedReasonType ? this._translateService.instant(endedReasonType) : '';
      case this.visitorInfoFieldType.CLIENT_TYPE:
        const clientType = this._backendFieldConverterService.convertClientType(<number>this.visitorInfoField.value);
        return clientType ? this._translateService.instant(clientType) : '';
      default:
        return this.visitorInfoField.value;
    }
  }

  public hasValue(): boolean {
    return this.visitorInfoField.value !== null && this.visitorInfoField.value !== '' && typeof this.visitorInfoField.value !== 'undefined';
  }

  public hasCustomFieldValue(value): boolean {
    return value !== null && value !== '' && typeof value !== 'undefined';
  }

  public editEmail(): void {
    if (this.editingEmail) {
      this.editingEmail = false;
      const value = this.visitorInfoField.value;
      if (this.emailInput.nativeElement.checkValidity() && value && value !== this._lastEmail) {
        this._bcRestApi.setTextChatEmail(this.visitorInfoField.workItemId, value);
      } else {
        this.visitorInfoField.value = this._lastEmail;
      }
    } else {
      this.editingEmail = true;
      this._lastEmail = <string>this.visitorInfoField.value;
      this._changeDetector.detectChanges();
      this.emailInput.nativeElement.focus();
    }
  }

  public editPhone(): void {
    if (this.editingPhone) {
      this.editingPhone = false;
      const value = this.visitorInfoField.value;
      if (value && value !== this._lastPhone) {
        this._bcRestApi.setTextChatPhone(this.visitorInfoField.workItemId, value);
      } else {
        this.visitorInfoField.value = this._lastPhone;
      }
    } else {
      this.editingPhone = true;
      this._lastPhone = <string>this.visitorInfoField.value;
      this._changeDetector.detectChanges();
      this.phoneNumberInput.nativeElement.focus();
    }
  }

  public restrictPhone(): void {
    this._changeDetector.detectChanges();
    this.visitorInfoField.value = (<string>this.visitorInfoField.value).replace(this.phoneInputAllowed, '');
  }
}
